module.exports = __webpack_public_path__ + "static/media/im.1239d978.webp";